import React from "react";
import Section from "../Common/Section";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {motion} from 'framer-motion'
import AnimatedWaveSvg from '../Common/Framer/AnimatedWaveSvg'

import FramerTextReveal from '../Common/Framer/FramerTextReveal'

import './NeighborhoodHomeSection.css'

import coverImage from '../../img/neighborhood/waterfront.png'

export default function NeighborhoodHomeSection() {
    return (
        <Section id="neighborhood" className="neighborhood-home-section">
        <AnimatedWaveSvg direction="right" />
        <div className="neighborhood-content-wrapper">
        <Row className="neighborhood-home-section-row flex-column-reverse flex-lg-row">
                <Col md={12} lg={6} className="neighborhood-home-section-content-container">
                    <motion.img
                        src={coverImage}
                        className="neighborhood-home-section-image"
                        alt="Club room and bar"
                        initial={{ x: -100, opacity: 0.5 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{
                            type: "spring",
                            stiffness: 60,
                            damping: 15,
                            delay: 0.2
                        }}
                        viewport={{ once: true, amount: 0.1 }}
                    />
                </Col>
                <Col md={12} lg={6} className="neighborhood-text-column">
                    <div className="neighborhood-home-section-text-container">
                        <FramerTextReveal>
                            <h4 className="neighborhood-pre-text">Easy Access to NYC and the Path</h4>
                        </FramerTextReveal>
                        <FramerTextReveal delay={0.25}>
                            <h1 className="neighborhood-home-section-main-text">Neighborhood</h1>
                        </FramerTextReveal>
                        <FramerTextReveal delay={0.35}>
                            <p className="neighborhood-home-section-description">
                            Aqua offers the perfect balance of neighborhood charm and city access. Ideally located in Bayonne’s waterfront district, MOTBY, our community provides residents with seamless connections to Manhattan via nearby light rail, shuttle service to the PATH, and the upcoming NYC Ferry. As one of the premier <Link to="/neighborhood" className="hyperlink-text">rentals in Bayonne,</Link> Aqua places you near local parks, shoreline paths, and dining options- blending comfort, convenience, and city energy. Discover the best apartments for rent in Hudson County, NJ and experience refined living in our luxury apartments. 
                            </p>
                        </FramerTextReveal>
                        <FramerTextReveal delay={0.45}>
                            <Link to="/neighborhood">
                                <Button className="neighborhood-home-section-button">
                                    Explore Our Neighborhood
                                </Button>
                            </Link>
                        </FramerTextReveal>
                    </div>
                </Col>
            </Row>
        </div>
    </Section>
    );
}